module.exports = __webpack_public_path__ + "img/homeTitle.7729546c.png";